export default __webpack_public_path__ + "images/loggedout/home/mweb-portrait-homepage-splashee@2x-40278babea14bcf74592a797d63730e0.png";